module.exports = "<svg class=\"sv-svg-icon\" role=\"img\"><use></use></svg>\n";